import React, { useState, useMemo, useEffect } from "react";
import { Col, Row, FormGroup } from "reactstrap";
import { Query } from "react-apollo";
import { withRouter, Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Loading from "../Loading/Loading";
import EditDeleteButton from "../EditDeleteButton";
import gql from "graphql-tag";
import {
  dateFormatter,
  documentCategoryFormatter,
  executionContextFormatter,
} from "../../utils/Formatters";
import { getDocumentTypeQuery } from "../../queries/Queries";

const deleteMutation = gql`
  mutation deleteDocumentTypeMutation($id: UUID) {
    deleteDocumentType(id: $id)
  }
`;

const DocumentTypes = ({ history }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [totalItems, setTotalItems] = useState(0);
  const [data, setData] = useState(null);

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder }
  ) => {
    setCurrentPage(page);
    setPageSize(sizePerPage);
    setSortField(sortField);
    setSortOrder(sortOrder);
  };

  const columns = useMemo(
    () => [
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
      {
        dataField: "documentCategory",
        text: "Document Category",
        sort: true,
        formatter: documentCategoryFormatter,
      },
      {
        dataField: "executionContext",
        text: "Execution Context",
        sort: true,
        formatter: executionContextFormatter,
      },
      {
        dataField: "created",
        text: "Created",
        sort: true,
        formatter: (cell, row) => dateFormatter(row.created),
      },
      {
        dataField: "createdBy",
        text: "Created By",
        sort: true,
        formatter: (cell, row) => row.createdBy || " ",
      },
      {
        dataField: "updated",
        text: "Updated",
        sort: true,
        formatter: (cell, row) =>
          row.updated ? dateFormatter(row.updated) : " ",
      },
      {
        dataField: "updatedBy",
        text: "Updated By",
        sort: true,
        formatter: (cell, row) => row.updatedBy || " ",
      },
      {
        dataField: "actions",
        text: " ",
        isDummyField: true,
        formatter: (cell, row) => (
          <EditDeleteButton
            id={row.id}
            history={history}
            editUrl={`/document-types/edit/${row.id}`}
            deleteMutation={deleteMutation}
            deleteRefetchQueries={[
              {
                query: getDocumentTypeQuery,
                variables: {
                  pageNumber: currentPage - 1,
                  pageSize,
                  sort: {
                    orders: [{ property: sortField, direction: sortOrder }],
                  },
                },
              },
            ]}
          />
        ),
      },
    ],
    [history, currentPage, pageSize, sortField, sortOrder]
  );

  return (
    <div className='manage-users'>
      <Row className='subheader'>
        <Col className='col-8'>
          <h1>Billing Details</h1>
        </Col>
        <Col className='col-4'>
          <FormGroup>
            <Link
              to={"/document-types/create"}
              className='btn btn-primary pull-right'
            >
              {" "}
              <i className='icon ion-plus-round'></i>&nbsp;&nbsp;New{" "}
            </Link>
          </FormGroup>
        </Col>
      </Row>
      <div className='page-cnt'>
        <Row>
          <Query
            query={getDocumentTypeQuery}
            variables={{
              pageNumber: currentPage - 1,
              pageSize,
              sort: { orders: [{ property: sortField, direction: sortOrder }] },
            }}
            onCompleted={(data) => {
              const newTotalItems = data.findAllDocumentType.totalElements;
              if (totalItems !== newTotalItems) {
                setTotalItems(newTotalItems);
                if (currentPage > Math.ceil(newTotalItems / pageSize)) {
                  setCurrentPage(Math.ceil(newTotalItems / pageSize));
                }
              }
            }}
          >
            {({ loading, error, data }) => {
              if (loading) return <Loading />;
              if (error) return <p>Error</p>;

              if (
                !data ||
                !data.findAllDocumentType ||
                !Array.isArray(data.findAllDocumentType.content)
              )
                return <p>No Data</p>;

              return (
                <React.Fragment>
                  <Col>
                    <h3>Billing Document Types</h3>
                  </Col>
                  <Col sm='12'>
                    <BootstrapTable
                      classes='table-hover'
                      wrapperClasses='table-responsive'
                      bordered={false}
                      keyField='id'
                      data={data.findAllDocumentType.content}
                      columns={columns}
                      remote={{
                        filter: false,
                        pagination: true,
                        sort: true,
                      }}
                      sort={{
                        dataField: sortField,
                        order: sortOrder,
                      }}
                      pagination={paginationFactory({
                        page: currentPage,
                        sizePerPage: pageSize,
                        totalSize: totalItems,
                        sizePerPageList: [
                          { text: "5", value: 5 },
                          { text: "10", value: 10 },
                          { text: "20", value: 20 },
                        ],
                      })}
                      onTableChange={handleTableChange}
                      rowStyle={{ cursor: "pointer" }}
                      rowEvents={{
                        onClick: (e, row) => {
                          if (e.target.tagName !== "TD") return;
                          history.push(`/document-types/${row.id}`);
                        },
                      }}
                    />
                  </Col>
                </React.Fragment>
              );
            }}
          </Query>
        </Row>
      </div>
    </div>
  );
};

export default withRouter(DocumentTypes);
